module.exports = __webpack_public_path__ + "static/media/9_l_provoda_0_0.51794bb3.png";